var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',{staticClass:"pretty-date",attrs:{"title":_vm.date}},[_vm._v(_vm._s(_vm.formattedDate))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }